<template>
  <i-dx-popup :popupVisible="popupVisible" :title="title" @popupCloseButtonClick="closeBtn" :height="'685'" width="980px">
    <template v-slot:grid>
      <div class="v-application" style="display: block !important; ">
        <v-row no-gutters class="px-6 pb-5 pt-0">
          <v-col cols="4" class="pr-4">
            <div class="editor-label">구분</div>
            <v-card :height="456">
              <DxDataGrid
                :ref="eduDivListRef"
                :data-source="eduDivList"
                key-expr="minorCd"
                height="100%"
                :selection="{ mode: 'single' }"
                :focusedRowIndex="0"
                :focused-row-enabled="true"
                @focused-row-changed="onFocusedType"
              >
                <DxColumn data-field="minorNm" data-type="string" alignment="left" caption="구분명" :allow-editing="false" />
              </DxDataGrid>
            </v-card>
          </v-col>
          <v-col cols="8" class="px-2">
            <div class="editor-label">소구분</div>
            <v-card :height="456">
              <DxDataGrid
                :ref="eduTypeListRef"
                :data-source="eduTypeList"
                key-expr="typeId"
                height="100%"
                :selection="{ mode: 'single' }"
                :focused-row-enabled="true"
                @focused-row-changed="onSelectionChanged"
              >
                <DxSelection mode="single" />
                <DxColumn
                  css-class="devest-grid-header-require"
                  data-field="typeNm"
                  data-type="string"
                  alignment="left"
                  caption="소구분명(작업명)"
                  :allow-editing="false"
                />
              </DxDataGrid>
            </v-card>
          </v-col>
        </v-row>

        <v-divider />
        <v-btn elevation="0" large color="primary" class="float-right rounded mr-6 mt-5" @click="btnApply">적용</v-btn>
      </div>
    </template>
  </i-dx-popup>
</template>

<script>
import IDxPopup from '@/components/common/iDxPopup.vue'
import baseview from '@/views/base/baseview.vue'
import BaseDataGrid from '@/views/base/BaseDataGrid.vue'
import { DxDataGridTypes } from 'devextreme-vue/data-grid'
// API
import { getCommonCode } from '@/api/common/commonApi'
import { getEducationType } from '@/api/leaderShip/educationPlan.js'

export default {
  mixins: [baseview, BaseDataGrid],
  components: {
    IDxPopup,
    DxDataGridTypes
  },
  props: {
    popupVisible: {
      type: Boolean,
      default: () => false
    },
    title: {
      type: String,
      default: () => ''
    }
  },
  data() {
    return {
      eduDivListRef: 'eduDivListRef',
      eduTypeListRef: 'eduTypeListRef',
      eduDivList: [],
      eduTypeList: [],
      educationDiv: {
        divCd: '', // 구분 코드
        divNm: '', // 구분 명
        eduContent: '' // 교육 내용
      }
    }
  },
  computed: {},
  watch: {
    // selected: {
    //   immediate: true, // 컴포넌트가 마운트 되는 즉시 실행
    //   handler(newVal, oldVal) {
    //     this.copySelected = JSON.parse(JSON.stringify(newVal))
    //   },
    //   deep: true //객체,배열 내부까지 감시
    // }
  },
  mounted() {
    this.searchData()
  },
  methods: {
    btnApply() {
      if (!this.educationDiv.divCd) {
        this.vSnackbar(this.$t('선택된 소구분이 없습니다.'), 'warn', 3000)
        return
      }
      this.vToastifyPrompt(
        this.$t('선택한 항목을 적용하시겠습니까?'),
        'info',
        current => {
          console.log('##', this.educationDiv)
          this.$emit('apply', this.educationDiv)
        },
        null,
        true
      )
    },
    async searchData() {
      this.openLoading()
      getCommonCode('EDU001')
        .then(res => {
          this.eduDivList = res.list
        })
        .catch(() => {
          this.endLoading()
        })
        .finally(() => {
          this.searchDetail(this.eduDivList[0].minorCd)
        })
    },
    closeBtn() {
      this.$emit('popupClose')
    },
    // 구분 선택
    onFocusedType(e) {
      this.educationDiv.divCd = e.row.data.minorCd
      this.educationDiv.divNm = e.row.data.minorNm
      this.searchDetail(e.row.key)
    },
    onSelectionChanged(e) {
      this.educationDiv.eduContent = e.row.data.eduContent
    },
    searchDetail(divCd) {
      this.openLoading()
      getEducationType({ divCd: divCd })
        .then(res => {
          this.eduTypeList = res.list
          this.endLoading()
        })
        .catch(() => {
          this.endLoading()
        })
    }
  }
}
</script>

<style lang="scss" scoped></style>
